module.exports = "//public.getcloudapp.com/packs/media/images/prize-a17bf730199e527708899e22e09410a1.svg";